export default "__VITE_ASSET__6ceb571e__"